import React from 'react';
import { NavLink, useParams, useLocation } from 'react-router-dom';
import { Form, Row, Col, Tooltip, OverlayTrigger } from 'react-bootstrap';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import queryString from "query-string";
import ReCAPTCHA from "react-google-recaptcha";
import { Toaster } from 'react-hot-toast';
import { PatternFormat as NumberFormat } from 'react-number-format';

import CsLineIcons from '../../cs-line-icons';
import { register } from "../../actions/auth";
import { settings as pageSettings } from '../../actions/page';
import LayoutFullPage from '../../layout/FullPage';
import Header from '../../layout/header';
import ConditionalButton from '../../layout/conditional-button';

import { development_mode, loginUrl } from '../../utils/api';
import { phoneInputValue } from '../../utils/string';
import { tokenize } from '../../actions/auth';
import { FERADEL_LOGO_PATH } from '../../constants/brand';

class Register extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: this.email || "",
            password: "",
            firstName: this.props.firstName || "",
            lastName: this.props.lastName || "",
            phone: this.props.phone || "",
            complexity: 0,
            valid: development_mode,
            error: {
                has: false,
                text: "",
                style: "warning"
            },
            seconnds: 5
        }
    }

    onChange = (e) =>
        this.setState({
            [e.target.name]: e.target.value,
        });
    
    onPasswordChange = (e) => {
        const password = e.target.value;
        let bitmask = 0;
        let complexity = 0;
        if (/[a-z]/.test(password)) bitmask += 1;
        if (/[A-Z]/.test(password)) bitmask += 2;
        if (/\d/.test(password)) bitmask += 4;
        if (/[^a-zA-Z0-9]/.test(password)) bitmask += 8;
        if (password.length > 10) bitmask += 16;
        
        while (bitmask) {
            complexity += bitmask & 1;
            bitmask >>= 1;
        }

        this.setState({
            password,
            complexity
        })
    }
    
    onCaptchaChange = (value) => {
        this.setState({
            ...this.state,
            valid: true
        })
    }
    
    onCaptchaErrored = (value) => {

    }

    onCaptchaExpired = (value) => {

    }

    countDown = () => {
        if (this.state?.seconds <= 0) {
            clearTimeout(this.countdownTimer);
            return;
        };
    
        this.countdownTimer = setTimeout(() => {
            const __seconds = this.state?.seconds || 0;
            this.setState({
                seconds: __seconds - 1,
                error: {
                    has: true,
                    text: `Email is already registered, forwarding to login page in ${__seconds}s.`,
                    style: "info"
                }
            }, this.countDown);
                
        }, 1000);
    }
    
    forward = (delay) => {
        this.setState({
            seconds: Math.round(delay / 1000)
        });
    
        this.countDown();
    
        setTimeout(() => {
            window.location.href = loginUrl();
        }, delay);
    }

    onSubmit = async (e) => {
        e.preventDefault();
        const result = await this.props.register({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phone: this.state.phone,
            email: this.state.email,
            password: this.state.password
        });
        // 
        switch (result?.status) {
            case 200: // user created
                await this.props.tokenize(result.token);
                window.location.href = `/dashboard?action=subscribe&category=${this.props.params.category}`;
                break;
            case 202: // user exists
                this.setState({
                    ...this.state,
                    error: {
                        has: true,
                        text: `Email is already registered, forwarding to login page in ${this.state.seconnds}s.`,
                        style: "info"
                    }
                });
                this.forward(5000);
                break;
            default:
                break;
        }
    };

    componentDidUpdate(prevProps) {
    }

    async componentDidMount() {
        await this.props.pageSettings();
    }
    
    get email() {
        const queryParams = queryString.parse(window.location.search)
        return queryParams["e"] || "";
    }

    get leftSide() {
        return (
            <div className="min-h-100 d-flex align-items-center">
                <div className="w-100 w-lg-75 w-xxl-50">
                    <div>
                        <div className="mb-5">
                            <h1 className="display-3 text-white">{this.line(2)}</h1>
                        </div>
                        <p className="h6 text-white lh-1-5 mb-5" dangerouslySetInnerHTML={{__html: this.line(3)}}/>
                        <div className="mb-5">
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    line(index) {
        return (this.props?.page?.meta?.lines?.length > index) ? this.props.page.meta.lines[index] : "";
    }

    get rightSide() {
        return (
            <div className="sw-lg-70 min-h-100 bg-foreground d-flex justify-content-center align-items-center shadow-deep py-5 full-page-content-right-border">
                <div className="sw-lg-50 px-5">
                    <div className="sh-11">
                        <NavLink to="/">
                            <div className="logo-default" style={{ backgroundImage: `url("${FERADEL_LOGO_PATH}")` }} />
                        </NavLink>
                    </div>
                    <div className="mb-5">
                        <h2 className="cta-1 mb-0 text-primary">{ this.line(0) }</h2>
                        <h2 className="cta-1 text-primary">{ this.line(1) }</h2>
                    </div>
                    <div className="mb-5">
                        <p className="h6">Register your credentials to begin.</p>
                    </div>
                    <div>
                        <Row>
                            <Col sm="12">
                                <div className="mb-3 filled form-group tooltip-end-top">
                                    <CsLineIcons icon="email" />
                                    <Form.Control
                                        className="form-control"
                                        name="email"
                                        value={this.state.email}
                                        onChange={this.onChange}
                                        placeholder='Email'
                                        required />
                                </div>
                            </Col><Col sm="6">
                                <div className="mb-3 filled form-group tooltip-end-top">
                                    <CsLineIcons icon="user" />
                                    <Form.Control
                                        className="form-control"
                                        name="firstName"
                                        value={this.state.firstName}
                                        onChange={this.onChange}
                                        placeholder='First Name'
                                        required />
                                </div>
                            </Col><Col sm="6">
                                <div className="mb-3 filled form-group tooltip-end-top">
                                    <Form.Control
                                        className="form-control"
                                        name="lastName"
                                        value={this.state.lastName}
                                        onChange={this.onChange}
                                        placeholder='Last Name'
                                        style={{paddingLeft: "15px"}}
                                        required />
                                </div>
                            </Col><Col lg="12">
                                <div className="mb-3 filled form-group tooltip-end-top">
                                    <CsLineIcons icon="phone" />
                                    <NumberFormat format="(###) ###-####" mask="_" className="form-control" value={phoneInputValue(this.state.phone)} allowEmptyFormatting onChange={this.onChange} name="phone" />
                                </div>
                            </Col><Col sm="12">
                                <div className="mb-3 filled form-group tooltip-end-top">
                                    <CsLineIcons icon="lock-off" />
                                    <Form.Control
                                        className="form-control"
                                        type="password"
                                        placeholder=""
                                        name="password"
                                        value={this.state.password}
                                        onChange={this.onPasswordChange}
                                        required />
                                </div>
                            </Col>
                        </Row>
                        <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-bottom">Requires 1 uppercase, 1 lowercase, 1 number, and 1 special character and a total length of at least 10 characters.</Tooltip>}>
                        <Row className="gx-1" style={{marginBottom: "10px"}}>
                            <Col xs="2"></Col>
                            <Col xs="2">
                                <div className="rounded" style={{backgroundColor: `${this.state.complexity >= 1 ? "green": "red"}`, height: "12px"}}></div>
                            </Col><Col xs="2">
                                <div className="rounded" style={{backgroundColor: `${this.state.complexity >= 2 ? "green": "red"}`, height: "12px"}}></div>
                            </Col><Col xs="2">
                                <div className="rounded" style={{backgroundColor: `${this.state.complexity >= 3 ? "green": "red"}`, height: "12px"}}></div>
                            </Col><Col xs="2">
                                <div className="rounded" style={{backgroundColor: `${this.state.complexity >= 4 ? "green": "red"}`, height: "12px"}}></div>
                            </Col><Col xs="2">
                                <div className="rounded" style={{backgroundColor: `${this.state.complexity >= 5 ? "green": "red"}`, height: "12px"}}></div>
                                </Col>
                        </Row>
                        </OverlayTrigger>
                        {this.state?.error?.has ?
                            <Row>
                                <Col sm="12">
                                    <div className={`alert alert-${this.state.error?.style} rounded`} role="alert">{this.state.error?.text}</div>
                                </Col>
                            </Row> : ``}
                        <Row>
                            <Col sm="6">
                                {development_mode ? `` :
                                    <ReCAPTCHA
                                        sitekey="6LdgRQcUAAAAAFPiiSUX3hyPtnL7s24xFQIvzwxe"
                                        onChange={this.onCaptchaChange}
                                        onExpired={this.onCaptchaExpired}
                                        onErrored={this.onCaptchaErrored}
                                        size="compact"
                                    />
                                }
                            </Col><Col sm="6" style={{textAlign: "right"}}>
                                <ConditionalButton enabledVariant="outline-primary" display={true} enabled={this.state.valid} onEnabledClick={this.onSubmit}>Register</ConditionalButton>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    };


    render() {
        if (!this.props.page) return <></>;
        if (!this.props.page.meta) return <></>;

        return (
            <>
                <Toaster position='bottom-right' reverseOrder={false} />
                <Header title='Register' description='Register' />
                <LayoutFullPage left={this.leftSide} right={this.rightSide} background={this.props.page?.meta?.images?.background} />
            </>
        );
    }
};

Register.propTypes = {
    register: PropTypes.func.isRequired,
    authenticated: PropTypes.bool,
    page: PropTypes.object
};

const mapStateToProps = (state) => {
    return ({
        page: state.page
    });
};

export default connect(mapStateToProps, { register, pageSettings, tokenize })(Register);

